import { useState } from "react"

import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductCategoryObj } from "scrivito/Objs/ProductCategory/ProductCategoryObjClass"
import { useEvent } from "shared/lib/useEvent"

import { PortfolioProductSelectProps } from "../PortfolioProductSelect"
import { PortfolioProductSelectViewModel } from "../PortfolioProductSelectView"

export function usePortfolioProductSelectViewModel({
  onProductSelect,
  onProductCategorySelect,
  ...rest
}: PortfolioProductSelectProps): PortfolioProductSelectViewModel {
  const [selectedProductCategory, setSelectedProductCategory] =
    useState<ProductCategoryObj | null>(null)

  const handleCategorySelect = useEvent((obj: ProductCategoryObj) => {
    setSelectedProductCategory(obj as ProductCategoryObj)
    onProductCategorySelect(obj as ProductCategoryObj)
  })

  const handleProductSelect = useEvent((product: ProductObj) => {
    onProductSelect(product.get("productType"))
  })

  const handleBack = useEvent(() => {
    setSelectedProductCategory(null)
    onProductCategorySelect(null)
  })

  return {
    ...rest,
    onBack: handleBack,
    onProductSelect: handleProductSelect,
    onCategorySelect: handleCategorySelect,
    selectedProductCategory
  }
}
